/* eslint-disable quote-props */
export const baseEndpoint = 'https://maps.googleapis.com/maps/api/js';
export const version = 'quarterly';
export const libraries = 'places,geometry';
export const key = 'AIzaSyBg3iYyycTNutbbCzFmhd5W_kt4eodjbIQ';

// Vector Map ID provisioned in Cloud Console, same GCP project/API key as the internal
// geo-dotmaps-react app - reused directly since this app has no Places/POI toggle (only ever
// renders the one hardcoded `mapStylers` style below), so a single mapId is enough (see DOT-4736
// notes). Once mapId is set, Google ignores any inline `styles` array - see component-configs.js.
export const mapId = '825058ad479ef6fe32df54c8';

export const GOOGLE_MAPS_MAX_ZOOM = 22;
export const PROXIMITY_CLUSTER_MAX_ZOOM = 15;

export const mapStylers = [
  {
    'featureType': 'poi',
    'elementType': 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'labels.text',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    'featureType': 'poi.business',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    'featureType': 'transit',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }
];

export const whiteMapStylers = [
  {
    featureType: 'all',
    elementType: 'geometry.fill',
    stylers: [{ weight: '2.00'}]
  },
  {
    featureType: 'all',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#9c9c9c' }
    ]
  },
  {
    featureType: 'all',
    elementType: 'labels.text',
    stylers: [{ visibility: 'on' }]
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{ color: '#f2f2f2' }
    ]
  },
  {
    featureType: 'landscape',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffffff' }
    ]
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffffff' }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{ visibility: 'off' }
    ]
  },
  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      { saturation: -100 },
      { lightness: 45 }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: '#eeeeee' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#7b7b7b' }]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#ffffff' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [{ visibility: 'simplified' }]
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      { color: '#46bcec' },
      { visibility: 'on' }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [{ color: '#c8d7d4' }]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#070707' }]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#ffffff' }]
  }
];

export const searchedHighlightStyle = {
  zIndex: 10,
  strokeColor: 'rgba(64,110,227,0.6)',
  fillOpacity: 0,
  clickable: false
};
